import React from "react";
import { mockData } from "../mock";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "./ui/card";
import { Plane, Building2, Eye, Users } from "lucide-react";

const iconMap = {
  tours: Plane,
  clubes: Building2,
  partidos: Eye,
  shadowing: Users
};

const Services = () => {
  return (
    <section id="servicios" className="py-24 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Ofreciendo Experiencias Formativas a Medida para Agentes
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Desde visitas exclusivas a clubes de élite y shadowing en negociaciones reales hasta asistencia a entrenamientos profesionales, nos encargamos de cada detalle para garantizar una experiencia de aprendizaje transformadora que acelere tu desarrollo como agente FIFA.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-20">
          {mockData.services.map((service) => {
            const Icon = iconMap[service.tag];
            return (
              <Card
                key={service.id}
                className="group hover:shadow-2xl transition-all duration-300 border-2 hover:border-yellow-500 cursor-pointer overflow-hidden"
              >
                <CardHeader>
                  <div className="w-16 h-16 bg-gradient-to-br from-yellow-500 to-amber-500 rounded-xl flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300 shadow-lg">
                    <Icon className="h-8 w-8 text-gray-900" />
                  </div>
                  <CardTitle className="text-2xl font-bold text-gray-900 group-hover:text-yellow-600 transition-colors">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-gray-600 text-base mb-4 leading-relaxed">
                    {service.description}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>

        <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-3xl p-12 text-white text-center shadow-2xl">
          <h3 className="text-3xl md:text-4xl font-bold mb-6">
            ¿Buscas una Experiencia Formativa Única?
          </h3>
          <p className="text-xl text-gray-300 mb-8 max-w-3xl mx-auto">
            Experiencias personalizadas diseñadas específicamente para estudiantes de Agente 360. Desde visitas a clubes de élite hasta participación en reuniones reales, te sumergimos en la industria del fútbol profesional.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Services;
